import { currencies } from "./currencies";

const walletTypes = {
  fiat: "fiatWallet",
  crypto: "cryptoWallet",
};

const paymentTypes = {
  fiat: "fiat",
  crypto: "crypto",
}

const walletTypesEnumMapping = {
  fiat: 1,
  fiatWallet: 1,
  crypto: 2,
  cryptoWallet: 2
};

const walletValuesToWalletTypeMapping = {
  1: walletTypes.fiat,
  2: walletTypes.crypto
};

const walletValuesToCurrenciesMapping = {
  [walletTypesEnumMapping.fiat]: currencies.NGN,
  [walletTypesEnumMapping.crypto]: currencies.MTK
};

export {
  walletTypes,
  walletTypesEnumMapping,
  paymentTypes,
  walletValuesToWalletTypeMapping,
  walletValuesToCurrenciesMapping
};